module.exports = __webpack_public_path__ + "img/compresor-1.9c1dfe83.png";